export function to_svg_data_uri(data: string) {
    return 'data:image/svg+xml;base64,'+window.btoa(unescape(encodeURIComponent(data)));
}

const min = Math.min;
const max = Math.max;

function linregress(values_x: number[], values_y: number[]) {
    let sum_x = 0;
    let sum_y = 0;
    let sum_xy = 0;
    let sum_xx = 0;
    let count = 0;

    /*
     * We'll use those variables for faster read/write access.
     */
    let x = 0;
    let y = 0;
    let values_length = values_x.length;

    if (values_length != values_y.length) {
        throw new Error('The parameters values_x and values_y need to have same size!');
    }

    /*
     * Nothing to do.
     */
    if (values_length === 0) {
        return [ [], [] ];
    }

    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let v = 0; v < values_length; v++) {
        x = values_x[v];
        y = values_y[v];
        sum_x += x;
        sum_y += y;
        sum_xx += x*x;
        sum_xy += x*y;
        count += 1;
    }

    /*
     * Calculate m and b for the formular:
     * y = x * m + b
     */
    let slope = (count*sum_xy - sum_x*sum_y) / (count*sum_xx - sum_x*sum_x);
    let intercept = (sum_y/count) - (slope*sum_x)/count;

    // y = x * m + b;

    return {
        slope, intercept
    };
}



export function make_graph_svg(data: number[][], labels: string[], header: string){
    let data_x = data[0];
    let data_y = data[1];

    let line_args: any = linregress(data_x, data_y);
    let slope: number = line_args.slope;
    let intercept: number = line_args.intercept;

    let x_min = min(...data_x);
    let x_max = max(...data_x);

    let y_min = min(...data_y);
    let y_max = max(...data_y);

    //# increase range by 20% and 30%
    let x_range = x_max - x_min;
    let x_center = (x_max + x_min) / 2;
    x_range *= 1.3;
    x_min = x_center - x_range / 2;
    x_max = x_center + x_range / 2;

    let y_range = y_max - y_min;
    let y_center = (y_max + y_min) / 2;
    y_range *= 1.2;
    y_min = y_center - y_range / 2;
    y_max = y_center + y_range / 2;

    function to_range(coord: number, min: number, max: number, width: number, offset: number=0) {
        return offset + width * (coord - min) / (max - min)
    }

    let circle_elements = "";
    for(const i of Array(data_x.length).keys()){
        let x = to_range(data_x[i], x_min, x_max, 800, 100);
        let y = 1000 - to_range(data_y[i], y_min, y_max, 800, 100);
        circle_elements += `\t<circle cx="${x}" cy="${y}" r="10" fill="red" /> \n`
    }
    function e_notation_number(number: number, significant_digits: number) {
        return number.toExponential(significant_digits)
    }

    let x_tick_elements = "";
    let y_tick_elements = "";
    for(const i of Array(5).keys()) {
        let tick_x_value = x_min + i / 4 * (x_max - x_min);
        let tick_svg_x = to_range(tick_x_value, x_min, x_max, 800, 100);
        x_tick_elements += `<rect x="${tick_svg_x}" y="948" width="1" height="10"
         style="fill:rgb(255,255,255);stroke-width:6;stroke:rgb(0,0,0)"></rect>
         <text x="${tick_svg_x}" y="1000" class="tick" text-anchor="middle">${e_notation_number(tick_x_value, 2)}</text>
         `

        let tick_y_value = y_min + i / 4 * (y_max - y_min);
        let tick_svg_y = 1000 - to_range(tick_y_value, y_min, y_max, 800, 100);
        y_tick_elements += `<rect x="48" y="${tick_svg_y}" width="10" height="1"
         style="fill:rgb(255,255,255);stroke-width:6;stroke:rgb(0,0,0)"></rect>
         <text x="45" y="${tick_svg_y}"  dominant-baseline="middle" text-anchor="end" class="tick">${e_notation_number(tick_y_value, 2)}</text>
         `
    }

    function line_function(x: number) {
        return slope * x + intercept
    }

    let y_at_x_min = line_function(x_min);
    let y_at_x_max = line_function(x_max);

    let regr_line_x1 = 100;
    let regr_line_y1 = 1000 - to_range(y_at_x_min, y_min, y_max, 800, 100);
    let regr_line_x2 = 900;
    let regr_line_y2 = 1000 - to_range(y_at_x_max, y_min, y_max, 800, 100);

    let svg = `
    <svg height="1080px" width="1230px" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-130 0 1100 1080"
         xml:space="preserve" >
        <style type="text/css">
            .header {font: normal 40px sans-serif; fill: black; }
            .axis {font: normal 40px sans-serif; fill: black; }
            .tick {font: normal 40px sans-serif; fill: black; }
        </style>

        <defs>
            <pattern id="smallGrid" width="8" height="8" patternUnits="userSpaceOnUse">
                <path d="M 8 0 L 0 0 0 8" fill="none" stroke="gray" stroke-width="0.5"/>
            </pattern>
            <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
                <rect width="80" height="80" fill="url(#smallGrid)"/>
                <path d="M 80 0 L 0 0 0 80" fill="none" stroke="gray" stroke-width="1"/>
            </pattern>
        </defs>

        <line x1="${regr_line_x1}" y1="${regr_line_y1}" x2="${regr_line_x2}" y2="${regr_line_y2}" style="stroke:rgb(0,0,255);stroke-width:2" />

        <rect x="50" y="950" width="900" height="1" style="fill:rgb(255,255,255);stroke-width:3;stroke:rgb(0,0,0)"></rect>

        <rect x="50" y="50" width="1" height="900" style="fill:rgb(255,255,255);stroke-width:3;stroke:rgb(0,0,0)"></rect>
    ${circle_elements}
    ${x_tick_elements}
    ${y_tick_elements}
        <text x="50%" text-anchor="middle" y="50" class="header">${header}</text>

        <text x="-140" y="50%" dominant-baseline="middle" text-anchor="middle"  class="axis" style="writing-mode: tb;"
             transform="rotate(180 -140,500)">${labels[1]}</text>
        <text y="1030" x="50%" dominant-baseline="middle" text-anchor="middle"  class="axis" >${labels[0]}</text>

    </svg> `;

    return svg
}
